import { createQuery } from "@mostrans/web-components/helpers/graphqlHelpers";
import gql from "graphql-tag";

const GET_MASTER_TESTIMONI = gql`
query GetMasterTestimoni($startDate: String, $endDate: String) {
    getMasterTestimoni(start_date: $startDate, end_date: $endDate) {
      data {
        id
        user_id
        testimony
        url_image
        create_date
        create_by
        updated_date
        update_by
        deleted_date
        karyawan {
          id
          employee_id
          employee_name
          jabatan_id
          ptkp
          no_hp
          email_pribadi
          email_mostrans
          jabatan {
            id
            position_name
          }
        }
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }`

export const getMasterTestimoni = createQuery({
  query: GET_MASTER_TESTIMONI,
  defaultValue: [],
  initialVariables: {
    startDate: null,
    endDate: null
  },
  selector: "getMasterTestimoni.data",
  responseSelector: "getMasterTestimoni.response"
})

const GET_DETAIL_MASTER_TESTIMONI = gql`
query GetDetailMasterTestimoni($getDetailMasterTestimoniId: Int) {
    getDetailMasterTestimoni(id: $getDetailMasterTestimoniId) {
      data {
        id
        user_id
        testimony
        url_image
        create_date
        create_by
        updated_date
        update_by
        deleted_date
        karyawan {
          id
          employee_id
          employee_name
          jabatan_id
          email_pribadi
          email_mostrans
          jabatan {
            id
            position_name
          }
        }
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }`

export const getDetailMasterTestimoni = createQuery({
  query: GET_DETAIL_MASTER_TESTIMONI,
  defaultValue: null,
  initialVariables: { getDetailMasterTestimoniId: null },
  selector: "getDetailMasterTestimoni.data",
  responseSelector: "getDetailMasterTestimoni.response"
})

const GET_MASTER_TESTIMONI_FOR_PUBLIC = gql`
query GetMasterTestimoniForPublic {
  getMasterTestimoniForPublic {
    data {
      id
      user_id
      testimony
      url_image
      create_date
      create_by
      deleted_date
      update_by
      updated_date
      karyawan {
        id
        employee_id
        employee_name
        jabatan {
          id
          position_name
        }
      }
    }
    response {
      status
      errMsg
      id_affected
    }
  }
}`

export const getMasterTestimoniForPublic = createQuery({
  query: GET_MASTER_TESTIMONI_FOR_PUBLIC,
  defaultValue: null,
  initialVariables: {},
  selector: "getMasterTestimoniForPublic.data",
  responseSelector: "getMasterTestimoniForPublic.response"
})